module.exports = __webpack_public_path__ + "static/img/icon_search@2x.0fbfff2b.png";